import styled from 'styled-components';
import { useSettingVariablesValueContextHook } from '../../../../contexts/SettingVariablesContext';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { useEffect, useState } from 'react';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { AnalyticsApi } from '../../../../../../../apis/AnalyticsApi';
import { LucideCircleAlert } from 'lucide-react';
import { STOCK_CYCLE_DATA_SERVICE } from '../../../../service/stockCycleDataService';

const StyledContainer = styled.div`

`;


export function OutlierWarningPopoverFragment({
    productOptionDetail = null,
    recommendPurchaseQty = null,
    totalAlreadyPurchasedQty = null
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const settingVariablesValueContextHook = useSettingVariablesValueContextHook();
    const settingVariables = settingVariablesValueContextHook.settingVariables;

    const productOptionIdsStr = [productOptionDetail?.productOptionId].join(',');

    // V3 는 제외된 주문 내역을 응답에 담아주므로 별도 조회가 필요없다.
    const v3OutlierOrders = STOCK_CYCLE_DATA_SERVICE.getOutlierOrders(productOptionDetail);
    const isV3 = STOCK_CYCLE_DATA_SERVICE.isV3(productOptionDetail);

    const [fetchedOutlierOrderList, setFetchedOutlierOrderList] = useState(null);

    useEffect(() => {
        if (isV3) {
            return;
        }
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey || !productOptionIdsStr) {
            return;
        }
        handleFetchOrders();
    }, [
        isV3,
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
        productOptionIdsStr
    ]);

    const handleFetchOrders = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const response = await AnalyticsApi().searchOrders({
            headers: headers,
            params: {
                releaseFrom: settingVariables?.releaseFrom,
                releaseTo: settingVariables?.releaseTo,
                productOptionIds: productOptionIdsStr,
            }
        });

        let orderList;
        if (response?.content) {
            orderList = response?.content;
        }

        if (!orderList || orderList.length === 0) {
            return;
        }

        const outlierOrderList = [];
        orderList.forEach(order => {
            if (order?.releaseQty > productOptionDetail?.iqrData?.upperBound) {
                outlierOrderList.push(order);
            }
        })

        setFetchedOutlierOrderList(outlierOrderList);
    }

    const outlierOrderList = isV3 ? v3OutlierOrders : fetchedOutlierOrderList;
    const adjustedData = productOptionDetail?.adjustedData;

    let extraAddedQty = Math.max((((productOptionDetail?.releaseQty - totalAlreadyPurchasedQty - recommendPurchaseQty) * 0.7) - productOptionDetail?.inventoryStockDto?.stockUnit), 0).toFixed(2);

    return (
        <>
            <StyledContainer>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><LucideCircleAlert size={16} /> 이상치 발견</div>
                {isV3 &&
                    <div style={{ marginTop: '5px', fontSize: '12px', color: '#808080' }}>
                        <div>제외 {adjustedData?.outlierCount}건 / {adjustedData?.outlierQty}개</div>
                        <div>상한 {adjustedData?.outlierBound} (중앙값 {adjustedData?.medianOrderQty}, P90 {adjustedData?.highQuantileOrderQty}, 주문 {adjustedData?.orderCount}건)</div>
                    </div>
                }
                <div style={{ marginTop: '10px' }}>
                    <span
                        style={{ color: 'var(--greenColor1)', cursor: 'pointer' }}
                        onClick={() => {
                            // 클립보드 복사 extraAddedQty
                            navigator.clipboard.writeText(extraAddedQty);

                        }}
                    >
                        {extraAddedQty}
                    </span>개 를 더 구매하는것을 고려해 보세요.
                </div>
                <div style={{ marginTop: 20 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        {outlierOrderList?.map(order => {
                            return (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'space-between' }} key={order?.erpItemId}>
                                    <div style={{ flex: 1 }}>{order.receiver}</div>
                                    <div>▶️</div>
                                    <div style={{ width: '50px' }}>{order?.releaseQty}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </StyledContainer>
        </>
    );
}
